import { render, staticRenderFns } from "./ContactPosition.vue?vue&type=template&id=2968aca4&scoped=true"
import script from "./ContactPosition.vue?vue&type=script&lang=js"
export * from "./ContactPosition.vue?vue&type=script&lang=js"
import style0 from "./ContactPosition.vue?vue&type=style&index=0&id=2968aca4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2968aca4",
  null
  
)

export default component.exports